// Ticket 16: Admin Moderation Console API helpers

const BACKEND_URL = window.location.origin;

function getAuthToken() {
  return localStorage.getItem('token');
}

export async function searchUsers(q) {
  const token = getAuthToken();
  const res = await fetch(`${BACKEND_URL}/api/admin/users/search?q=${encodeURIComponent(q)}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  
  if (!res.ok) {
    throw new Error('Failed to search users');
  }
  
  return res.json();
}

export async function getUserModeration(userId) {
  const token = getAuthToken();
  const res = await fetch(`${BACKEND_URL}/api/admin/users/${userId}/moderation`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  
  if (!res.ok) {
    throw new Error('Failed to get user moderation data');
  }
  
  return res.json();
}

export async function adminModerationAction(userId, action, reason = null) {
  const token = getAuthToken();
  const res = await fetch(`${BACKEND_URL}/api/admin/users/${userId}/moderation/action`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ action, reason }),
  });
  
  if (!res.ok) {
    throw new Error('Failed to perform moderation action');
  }
  
  return res.json();
}

export async function getModerationLogs(params = {}) {
  const token = getAuthToken();
  
  const queryParams = new URLSearchParams();
  if (params.page) queryParams.append('page', params.page);
  if (params.page_size) queryParams.append('page_size', params.page_size);
  if (params.type) queryParams.append('type', params.type);
  if (params.target_id) queryParams.append('target_id', params.target_id);
  if (params.reporter_id) queryParams.append('reporter_id', params.reporter_id);
  
  const res = await fetch(`${BACKEND_URL}/api/admin/moderation/logs?${queryParams}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  
  if (!res.ok) {
    throw new Error('Failed to get moderation logs');
  }
  
  return res.json();
}
